import { defineMessages } from 'react-intl';

export default defineMessages({
    toDateGreaterThanFromDate:{
        id: "twia-tfpa.views.claims-landing.To Date must be greater than From Date",
        defaultMessage: "\"To Date\" must be greater than \"From Date\""
    }
})